import axios from 'axios'

const BASE_URL = process.env.VUE_APP_USER_API

export const putActiveClientDoctor = ({ params }) => {
  return axios({
    method: 'PUT',
    //headers: { 'content-type': 'multipart/form-data' },
    url: `${BASE_URL}/client-doctor-activation/${params.activeToken}`,
    data: {
      email: params.email,
      password: params.password
    }
  })
}

export const getActiveClientDoctor = ({ params }) => {
  return axios({
    method: 'GET',
    url: `${BASE_URL}/activation-token-active/${params.activeToken}`
  })
}
